interface SectionTitleProps {
  label?: string;
  title: string;
  subtitle?: string;
  className?: string;
}

export default function SectionTitle({ label, title, subtitle, className = '' }: SectionTitleProps) {
  return (
    <div className={`mb-8 md:mb-10 ${className}`}>
      {label && (
        <span className="inline-block px-3 py-1 text-xs font-medium rounded-full border border-foreground-200 text-foreground-500 mb-3">
          {label}
        </span>
      )}
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-2 text-sm text-foreground-500 max-w-lg">{subtitle}</p>
      )}
    </div>
  );
}